export const getDateDropdownClassList = (isDropdownOpen: boolean, showTodayTomorrow: boolean) => {
  const dateDropdownClassList = ['date-dropdown'];
  if (isDropdownOpen) dateDropdownClassList.push('active');
  if (showTodayTomorrow) dateDropdownClassList.push('today-tomorrow-shown');
  return dateDropdownClassList.join(' ');
};

export const getTodayButtonClassList = (date: { day: number; month: number; year: number }) => {
  const currentDate = new Date();
  const todayButtonClassList = ['today-button', 'body'];
  const todayButtonHighlightClassList = ['today-button-highlight'];
  if (
    date.day === currentDate.getDate() &&
    currentDate.getMonth() === date.month &&
    currentDate.getFullYear() === date.year
  ) {
    todayButtonClassList.splice(todayButtonClassList.indexOf('body'), 1);
    todayButtonClassList.push('active', 'callout');
    todayButtonHighlightClassList.push('active');
  } else if (
    (date.day !== currentDate.getDate() && date.day !== currentDate.getDate() + 1) ||
    currentDate.getMonth() !== date.month ||
    currentDate.getFullYear() !== date.year
  ) {
    todayButtonClassList.push('neitherButtonSelected');
  }
  return {
    todayButtonClassList: todayButtonClassList.join(' '),
    todayButtonHighlightClassList: todayButtonHighlightClassList.join(' '),
  };
};

export const getTomorrowButtonClassList = (date: { day: number; month: number; year: number }) => {
  const currentDate = new Date();
  const tomorrowButtonClassList = ['tomorrow-button', 'body'];
  const tomorrowButtonHightlightClassList = ['tomorrow-button-highlight'];
  if (
    date.day === currentDate.getDate() + 1 &&
    currentDate.getMonth() === date.month &&
    currentDate.getFullYear() === date.year
  ) {
    tomorrowButtonClassList.splice(tomorrowButtonClassList.indexOf('body'), 1);
    tomorrowButtonClassList.push('active', 'callout');
    tomorrowButtonHightlightClassList.push('active');
  } else if (
    (date.day !== currentDate.getDate() && date.day !== currentDate.getDate() + 1) ||
    currentDate.getMonth() !== date.month ||
    currentDate.getFullYear() !== date.year
  ) {
    tomorrowButtonClassList.push('neitherButtonSelected');
  }
  return {
    tomorrowButtonClassList: tomorrowButtonClassList.join(' '),
    tomorrowButtonHightlightClassList: tomorrowButtonHightlightClassList.join(' '),
  };
};

export const handleLastDayOfMonth = (
  today: Date,
  setLocalDate: (v: { day: number; month: number; year: number }) => void,
  setDate: (v: { name: string; value: Date }) => void,
) => {
  // handles when today is the last day of the month but we're in december
  if (today.getMonth() === 11) {
    setLocalDate({
      day: 1,
      month: 0,
      year: today.getFullYear() + 1,
    });
    setDate({
      name: 'date',
      value: new Date(today.getFullYear() + 1, 0, 1),
    });
    return;
  }

  // otherwise today is the last day of the month but we're in the same year
  setLocalDate({
    day: 1,
    month: today.getMonth() + 1,
    year: today.getFullYear(),
  });
  setDate({
    name: 'date',
    value: new Date(today.getFullYear(), today.getMonth() + 1, 1),
  });
};
